export const stripeProductIds = {
    standard : 'price_1M5b5qAuxQbeF55soZs5bEWD',
    proHost: 'price_1MCsg8AuxQbeF55s2zCNNivK',
    proMax: 'price_1NG0CwAuxQbeF55sdLhmNHAf',
    partnerSilver: 'price_1NFLEEAuxQbeF55sDdERj3lT',
    partnerGold: 'price_1NFLF2AuxQbeF55sBYYZerBF',
    partnerPlatinum: 'price_1NFLFOAuxQbeF55s4ZevfbkF',
    admin: ''
}
